import React, {useEffect} from "react"
import {useLocation} from "react-router-dom"
import {CssBaseline, ThemeProvider} from "@mui/material"
import theme from "../theme/theme"
import SideBar from "../components/SideBar/side-bar"
import {useDocumentTitle} from "../hooks/useDocumentTitle"
import PropTypes from "prop-types"
import {Box} from "@mui/system"
import SessionTimeout from "../../utils/session-timeout"
import RefreshToken from "../../utils/refresh-token"
import Header from "../components/Header/header"
import {AlertListener} from "../components/SnackBar/snackbar-listener"
import {DuplaConfirmacaoListener} from "../components/DuplaConfirmacao/DuplaConfirmacaoListener"
import LoaderOverlay from "../components/LoaderOverlay/loader-overlay"
import Loader from "../components/Loader/loader"

const SideBarLayout = (
    {
        children,
        title,
        header,
        headerTitle,
        headerImage,
        loading = false,
        headerPosition = null,
        actionButton,
        variant = "v1",
        hideMenu = false,
    }) => {

    const isV2 = variant === "v2"
    const location = useLocation()

    useEffect(() => {
        if (!location.pathname.includes("solicitar-acesso")) {
            localStorage.setItem("current_page", location.pathname)
        }
    }, [location.pathname])

    useDocumentTitle(title)

    const body = document.body

    body.style.width = isV2 ? "100dvw" : "100dvwd"
    body.style.height = isV2 ? "100dvh" : "100dvhd"
    body.style.overflowX = isV2 ? "hidden" : "auto"

    return (
        <ThemeProvider theme={theme}>
            <SessionTimeout/>
            <RefreshToken/>
            <CssBaseline/>

            <Box
                sx={{
                    display: "flex",
                    gap: 3,
                    background: theme.palette.background.primary,
                    height: "100%",
                    minHeight: "100vh",
                    width: "100%",
                    overflowX: "auto",
                }}
            >
                {!hideMenu && <SideBar />}

                <Box
                    component="main"
                    sx={{
                        flex: 1,
                        minWidth: 0,
                        height: "100%",
                        width: "100%",
                        mb: isV2 ? 0 : "5%",
                        ml: {
                            lg: hideMenu ? 0 : "233px",
                            xxxs: "0px",
                        },
                        mr: {
                            lg: "24px",
                            xxxs: "0px",
                        },
                    }}
                >
                    <AlertListener/>
                    <DuplaConfirmacaoListener/>

                    {header ? (
                        <>
                            {!hideMenu && <Header
                                title={headerTitle}
                                imageBackground={headerImage || ''}
                                backgroundPosition={headerPosition}
                                actionButton={actionButton}
                                variant={variant}
                            />}
                            <Box
                                sx={{
                                    mt: {
                                        xxxs: "270px",
                                        lg: isV2 ? "100px" : "210px",
                                    },
                                    position: 'relative'
                                }}
                            >
                                {children}
                            </Box>
                        </>
                    ) : (
                        children
                    )}

                    {loading && (
                        <LoaderOverlay>
                            <Loader/>
                        </LoaderOverlay>
                    )}
                </Box>
            </Box>
        </ThemeProvider>
    )
}

SideBarLayout.propTypes = {
    children: PropTypes.node.isRequired,
    title: PropTypes.string,
    header: PropTypes.bool,
    headerTitle: PropTypes.string,
    headerImage: PropTypes.string,
    loading: PropTypes.bool,
    headerPosition: PropTypes.string,
    actionButton: PropTypes.node,
    variant: PropTypes.oneOf(["v1", "v2"]),
    hideMenu: PropTypes.bool,
}

SideBarLayout.defaultProps = {
    title: "C2P",
    variant: "v1"
}

export default SideBarLayout